import { render, staticRenderFns } from "./ModalMaisInfo.vue?vue&type=template&id=1bad9f11"
import script from "./ModalMaisInfo.vue?vue&type=script&lang=js"
export * from "./ModalMaisInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports